import * as React from 'react'
import { Grid } from '@mui/material'
import ToSocialBtn from '../../component/Buttons/ToSocialBtn';
import SwitchNFTtype from '../../component/Buttons/SwitchNFTtype';

const ToSocial = () => {
    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
        >
            <ToSocialBtn
                type="Discord"
                linkUrl="https://discord.com/channels/1249127050950873208/1249127051521294440"
            />
            <ToSocialBtn
                type="Telegram"
                linkUrl="https://t.me/CSPX_Ecosystem"
            />
            <ToSocialBtn
                type="Twitter"
                linkUrl="https://twitter.com/Cryptominespace"
            />
            <ToSocialBtn
                type="Youtube"
                linkUrl="https://www.youtube.com/watch?v=b5NbbE3-Aw4"
            />
            <SwitchNFTtype />
        </Grid>
    )
}

export default ToSocial
